<template>
  <div>
    <div class="bottomFix">
      <div class="bottomFixAuto">
        <span class="bottomFixImg"><img src="./bottomFix.png" alt="云标物联多媒体广告信息发布系统,400-168-1191" title="云标物联多媒体广告信息发布系统,400-168-1191" style="width:100%;"></span>
        <div>
          <p class="tit flex">一次咨询，<span>给您一个满意的方案</span>  <a href="tencent://message/?uin=2605568468" title="QQ联系服务人员" class="Sbtn font14">
            点击在线咨询
          </a> </p>
          <ul class="bottomFixW">
            <li style="margin-right:10px;"><a href="javascript:;" title="">销售咨询：<span>18500058818</span></a></li>
            <li style="margin-right:10px;"><a target="_blank" href="javascript:;" title="13611292757"><span>13611292757</span></a></li>
            <li style="margin-right:10px;"><a target="_blank" href="javascript:;" title="15601012858 "><span>15601012858 </span></a></li>
          </ul>
        </div>
        <span class="bottomFixImg1" @click="die()"><img src="http://static.yunbiaowulian.com/imgserver/static//css/front/images/bottomFix1.png" alt="云标物联多媒体广告信息发布系统,400-168-1191" title="云标物联多媒体广告信息发布系统,400-168-1191" style="width:100%;"></span>
      </div>
    </div>
    <div class="bottomFixAuto1" @click="show()">
      <img src="./bottomFix2.png" alt="云标物联多媒体广告信息发布系统,400-168-1191" title="云标物联多媒体广告信息发布系统,400-168-1191">
    </div>
    <div class="bottomFix2">
      <a class="phonePC" href="tencent://message/?uin=2605568468" title="2605568468">
        <img src="./qq.png" alt="" title=""><span>QQ咨询</span></a>
      <a class="phoneQQ" href="mqqwpa://im/chat?chat_type=wpa&uin=2605568468&version=1&src_type=web&web_src=qq.com" title="2605568468">
        <img src="./qq.png" alt="" title=""><span>QQ咨询</span></a>
      <a target="_blank" href="tel:18500058818" title="18500058818"  style="border-left:1px solid rgba(113,13,17,0.8); color:rgba(113,13,17,0.8);">
        <img src="./phone.png" alt="" title=""><span>电话咨询</span></a>
    </div>

  </div>
</template>
<script type="text/ecmascript-6">
    export default {
      methods: {
            die: function () {
              $(".bottomFix").hide();
              $('.bottomFixAuto1').css("display",'block');
            },
            show:function () {
              $(".bottomFix").show();
              $('.bottomFixAuto1').css("display",'none');
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .bottomFixAuto1
    position: fixed;
    bottom: 0;
    left: 50%;
    z-index: 999;
    display: none;
  .bottomFix
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background rgba(73,43,43,0.8)
    z-index: 9999;
    box-sizing: border-box;
    background-size: cover;
    .bottomFixAuto, .bottomFixW
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: flex-start;
    .bottomFixImg
      margin-right: 36px;
    .tit
      font-size: 28px;
      color: #fff;
      padding-top: 10px;
      align-items: center;
      span
        color: #f8d373;
        margin-right: 10px;
      .Sbtn
        color: #fff;
        padding: 3px 8px;
        border-radius: 4px;
        background: #ae4e4e;
        font-size: 16px;
  .bottomFixW
    justify-content: flex-start;
    li a
      display: inline-block;
      color: #fff;
      padding: 15px 0 0 0;
      font-size: 18px;
      &:hover
        text-decoration none
      &:focus
        text-decoration none
      span
        color:#f8d373;
  .bottomFix2
    display none
  .phoneQQ
    display none
  .bottomFixAuto1
    display none
@media (max-width: 750px) and (min-width: 320px)
  .bottomFix
    display: none;
  .bottomFix2
    display: block;
    width: 100%;
    overflow: hidden;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #fff;
    z-index: 99999;
    border-top: 1px solid #ccc;
    .phoneQQ
      display block
    .phonePC
      display none
    a
      display: block;
      padding: 15px 0;
      text-align: center;
      width: 50%;
      float: left;
      color: #333;
      box-sizing: border-box;
    img
      margin-right: 10px;


</style>



// WEBPACK FOOTER //
// src/components/bottomfix/bottomfix.vue